<template>
  <section :class="['section', sectionStyle]">
    <h3 v-if="showHeading" class="section-header">{{ heading }}</h3>
    <div v-html="htmlContent"></div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { marked, Tokens } from 'marked';

export default defineComponent({
  name: 'ContentSection',
  props: {
    heading: {
      type: String,
      default: '',
    },
    showHeading: {
      type: Boolean,
      default: true,
    },
    content: {
      type: String,
      default: '',
    },
    sectionStyle: {
      type: String,
      default: '',
    }
  },
  data() {
    const renderer = {
      link({href, title, text}: Tokens.Link): string{
        const linkData = {
          href,
          title,
          text
        }
        return `<a href="${href}" target="_blank" rel="noreferrer">${text}</a>`;
      }
    };
    
    marked.use({
        renderer 
    });
    return {
        htmlContent: marked.parse(this.content),
    }
  }
});
</script>
